module.exports = __webpack_public_path__ + "components/MapControl/svg/Sklep spożywczo-przemysłowy.svg?576147cd";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Sklep spożywczo-przemysłowy.svg
// module id = 2040
// module chunks = 0